import React, { useEffect, useState, useRef } from "react";
import {
  View,
  Button,
  TouchableOpacity,
  Text,
  ScrollView,
  Alert,
  StyleSheet,
  Modal,
  FlatList,
} from "react-native";
import { Calendar } from "react-native-calendars";

import { FontAwesome } from "@expo/vector-icons";

import Colors from "../../Resources/Color";
import Fonts from "../../Resources/Fonts";
import GlobalStyles from "../../Resources/Styles";

import { Ionicons } from "@expo/vector-icons";
import Bodyweight from "../Firestore/Bodyweight";
import Workout from "../Firestore/Workout";
import { useScreenDimensions, useDevice } from "../_layout";
import { useTranslation } from "react-i18next";
import { observer, Observer } from "mobx-react";
import { format } from "date-fns";

const AddToCalendarView = observer(({ isVisible, onClose, block, client }) => {
  const { t } = useTranslation();
  const year = new Date().getFullYear();
  const month = new Date().getMonth();
  const day = new Date().getDate();
  const today = new Date(year, month, day);
  const [currentMonth, setCurrentMonth] = useState(new Date());
  const { screenSize } = useScreenDimensions();

  const workouts = client.getWorkouts();
  const bodyweights = client.bodyweights;
  const tracs = client.tracs;
  const SIDE_MENU_SIZE = 200;

  const { isMobile } = useDevice();
  const [selectedWeek, setSelectedWeek] = useState(() => {
    // Find the workout with a date closest to today in the future
    const futureWorkouts = block.workouts
      .filter((w) => w.date && new Date(w.date) >= today)
      .sort((a, b) => new Date(a.date) - new Date(b.date));

    if (futureWorkouts.length > 0) {
      return futureWorkouts[0].week;
    }
    return 1; // Default to week 1 if no future workouts
  });

  // skip auto-propagation on initial mount
  // const isFirstAutoPropMount = useRef(true);

  const weekWorkouts = block.workouts
    .filter((workout) => workout.week === selectedWeek)
    .sort((a, b) => a.order - b.order);

  // const allSelected = weekWorkouts.some((w) => !w.auxDate);

  const workoutsOnCalendar = workouts.filter(
    (workout) => workout.block.id !== block.id
  );
  useEffect(() => {
    // On open, seed auxDate from saved date
    block.workouts.forEach((workout) => {
      workout.setProperty("auxDate", workout.date);
    });

    // Initialize currentMonth based on the selected week's workouts
    const selectedWeekWorkouts = block.workouts
      .filter((w) => w.week === selectedWeek && w.auxDate)
      .sort((a, b) => a.order - b.order);
    if (selectedWeekWorkouts.length > 0 && selectedWeekWorkouts[0].auxDate) {
      const firstAux = new Date(selectedWeekWorkouts[0].auxDate);
      // Always set to the 1st day of the month to avoid date issues
      const newMonthDate = new Date(
        firstAux.getFullYear(),
        firstAux.getMonth(),
        1
      );
      setCurrentMonth(newMonthDate);
    }
  }, []);

  const predictFutureDates = () => {
    const baseDates = weekWorkouts.map((w) => new Date(w.auxDate));
    // ensure auxDates are in ascending order for weekWorkouts by order
    const sortedAuxDates = [...baseDates].sort((a, b) => a - b);
    weekWorkouts.forEach((w, idx) => {
      const correctDate = sortedAuxDates[idx];
      if (w.auxDate && !isSameDay(new Date(w.auxDate), correctDate)) {
        w.setProperty("auxDate", correctDate);
      }
    });
    // build a sorted mapping of order -> baseDate by chronological order
    const baseMappings = weekWorkouts
      .map((w) => ({ order: w.order, date: new Date(w.auxDate), name: w.name }))
      .sort((a, b) => a.date - b.date);
    const startWeek = selectedWeek;
    const lastWeek = block.totalWeeks;

    for (let wk = startWeek + 1; wk <= lastWeek; wk++) {
      baseMappings.forEach(({ order, date: base, name }, idx) => {
        const nextWorkout = block.workouts.find(
          (w) => w.week === wk && w.order === order
        );
        if (!nextWorkout) return;

        if (!base) {
          nextWorkout.setProperty("auxDate", null);
          return;
        }
        const d = new Date(base);
        d.setDate(d.getDate() + 7 * (wk - startWeek));

        const hasPermanent = workoutsOnCalendar.some(
          (w) => w.date && isSameDay(new Date(w.date), d)
        );
        const hasEarlierAux = block.workouts
          .filter((x) => x.week < wk)
          .some((x) => x.auxDate && isSameDay(new Date(x.auxDate), d));

        if (!hasPermanent && !hasEarlierAux) {
          nextWorkout.setProperty("auxDate", d);
        } else {
          nextWorkout.setProperty("auxDate", null);
        }
      });
    }
  };

  // useEffect(() => {
  //   if (isFirstAutoPropMount.current) {
  //     isFirstAutoPropMount.current = false;
  //     return;
  //   }
  //   // if any workout in the selected week is still unassigned, do nothing
  //   if (allSelected) return;

  // }, [allSelected]);

  const CustomCalendarHeader = ({ currentMonth, onMonthChange }) => {
    const year = currentMonth.getFullYear();

    function capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    }
    const monthName = capitalizeFirstLetter(
      currentMonth.toLocaleString(
        client.coach ? client.coach.coachLanguage : "es",
        {
          month: "long",
        }
      )
    );

    const ChangeMonthButton = ({ nextMonth }) => {
      const [isHovered, setIsHovered] = useState(false);

      return (
        <TouchableOpacity
          onPress={() => (nextMonth ? onMonthChange(1) : onMonthChange(-1))}
          onMouseEnter={() => !isMobile && setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          style={{ opacity: isHovered ? 0.5 : 1 }}
        >
          <FontAwesome
            name={nextMonth ? "chevron-right" : "chevron-left"}
            size={24}
            color={Colors.bubbleColor}
          />
        </TouchableOpacity>
      );
    };

    return (
      <View
        style={{
          flexDirection: "row",
          alignItems: "center",
          paddingHorizontal: screenSize === "small" ? 8 : 8,
          marginBottom: 16,
        }}
      >
        <View style={GlobalStyles.Spacer} />
        <ChangeMonthButton nextMonth={false} />

        <View
          style={{
            width: screenSize === "small" ? "28%" : "30%",
            alignItems: "center",
          }}
        >
          <Text
            style={{ fontSize: 16, fontWeight: "bold", flexShrink: 1 }}
            numberOfLines={1}
          >
            {monthName}
          </Text>
          <Text style={{ textAlign: "center", fontSize: 12 }}>{year}</Text>
        </View>

        <ChangeMonthButton nextMonth={true} />
        <View style={GlobalStyles.Spacer} />
        <Buttons bool={false} />
        <Buttons bool={true} />
      </View>
    );
  };

  const CustomDayHeader = () => {
    return (
      <View
        style={{
          flexDirection: "row",
          height: 20,
          alignItems: "center",
        }}
      >
        {[
          "monHeader-string",
          "tueHeader-string",
          "wedHeader-string",
          "thuHeader-string",
          "friHeader-string",
          "satHeader-string",
          "sunHeader-string",
        ].map((day) => (
          <Text
            key={day}
            style={{
              color: "black",
              fontWeight: "bold",
              width: "100%",
              textAlign: "center",
            }}
          >
            {t(day)}
          </Text>
        ))}
      </View>
    );
  };

  const handleMonthChange = (offset) => {
    const currentYear = currentMonth.getFullYear();
    const currentMonthIndex = currentMonth.getMonth();

    // Calculate new month and year, handling year overflow properly
    const totalMonths = currentYear * 12 + currentMonthIndex + offset;
    const newYear = Math.floor(totalMonths / 12);
    const newMonth = ((totalMonths % 12) + 12) % 12; // Handle negative modulo

    // Always set to the 1st day of the month to avoid date overflow issues
    const newDate = new Date(newYear, newMonth, 1);

    setCurrentMonth(newDate);
  };

  const isSameDay = (date1, date2) => {
    return (
      date1.getDate() === date2.getDate() &&
      date1.getMonth() === date2.getMonth() &&
      date1.getFullYear() === date2.getFullYear()
    );
  };

  const CardView = observer(({ date }) => {
    const [isHovered, setIsHovered] = useState(false);

    const isSameMonth = date.month === currentMonth.getMonth() + 1;

    const isToday = isSameDay(
      today,
      new Date(date.year, date.month - 1, date.day)
    );

    const bodyweightForDate = bodyweights.find((bodyweight) =>
      isSameDay(
        new Date(bodyweight.date),
        new Date(date.year, date.month - 1, date.day)
      )
    );
    const workoutForDate = workoutsOnCalendar.find((workout) =>
      isSameDay(
        new Date(workout.date),
        new Date(date.year, date.month - 1, date.day)
      )
    );

    // Determine if this date is assigned to a workout in the selected week
    const selectedWeekDate = weekWorkouts.find((workout) =>
      isSameDay(
        new Date(workout.auxDate),
        new Date(date.year, date.month - 1, date.day)
      )
    );

    const isSelected = Boolean(selectedWeekDate);

    const blockWorkoutForDate = block.workouts.find(
      (workout) =>
        workout.week !== selectedWeek &&
        isSameDay(
          new Date(workout.auxDate),
          new Date(date.year, date.month - 1, date.day)
        )
    );

    const tracsForDate = tracs.find((trac) =>
      isSameDay(
        new Date(trac.date),
        new Date(date.year, date.month - 1, date.day)
      )
    );

    const handleDayPress = (day) => {
      const tappedDate = new Date(day.year, day.month - 1, day.day, 12);
      // 1) If any workout has a permanent .date on this day, do nothing
      const hasAlreadyWorkout = workoutsOnCalendar.some(
        (w) => w.date && isSameDay(new Date(w.date), tappedDate)
      );
      if (hasAlreadyWorkout) return;

      // Unselect if tapping a date already assigned to a workout in the selected week
      const selectedWorkout = weekWorkouts.find(
        (w) => w.auxDate && isSameDay(new Date(w.auxDate), tappedDate)
      );
      if (selectedWorkout) {
        selectedWorkout.setProperty("auxDate", null);
        // Normalize auxDates: oldest date → first workout, etc.
        const assignedDates = weekWorkouts
          .map((w) => w.auxDate)
          .filter((d) => d)
          .map((d) => new Date(d))
          .sort((a, b) => a - b);
        weekWorkouts.forEach((w, idx) => {
          if (idx < assignedDates.length) {
            const targetDate = assignedDates[idx];
            if (!isSameDay(new Date(w.auxDate), targetDate)) {
              w.setProperty("auxDate", targetDate);
            }
          } else if (w.auxDate) {
            w.setProperty("auxDate", null);
          }
        });
        return;
      }

      // Skip early if all weekWorkouts have an auxDate
      if (weekWorkouts.every((w) => w.auxDate)) {
        return;
      }

      // 2) Clear any existing auxDate on any workout with this date
      const conflictWorkout = block.workouts.find(
        (w) => w.auxDate && isSameDay(new Date(w.auxDate), tappedDate)
      );
      if (conflictWorkout) {
        conflictWorkout.setProperty("auxDate", null);
      }

      // 3) Assign this date to the next unassigned workout in the selected week
      const newWorkout = weekWorkouts.find((w) => !w.auxDate);
      if (newWorkout) {
        newWorkout.setProperty("auxDate", tappedDate);
      }
      // Normalize auxDates: oldest date → first workout, etc.
      const assignedDates = weekWorkouts
        .map((w) => w.auxDate)
        .filter((d) => d)
        .map((d) => new Date(d))
        .sort((a, b) => a - b);
      weekWorkouts.forEach((w, idx) => {
        if (idx < assignedDates.length) {
          const targetDate = assignedDates[idx];
          if (!isSameDay(new Date(w.auxDate), targetDate)) {
            w.setProperty("auxDate", targetDate);
          }
        } else if (w.auxDate) {
          w.setProperty("auxDate", null);
        }
      });

      const allSelected = !weekWorkouts.some((w) => !w.auxDate);

      if (allSelected) {
        predictFutureDates();
      }
    };

    return (
      <View
        style={{
          height: 60,
          width: "100%",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <TouchableOpacity
          onPress={() => {
            handleDayPress(date);
          }}
          style={{
            height: "100%",
            width: "60%",
            justifyContent: "center",
            alignItems: "center",
          }}
          onMouseEnter={() => !isMobile && setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <View
            style={{
              justifyContent: "flex-start",
              height: "100%",
              width: "100%",
              backgroundColor: isSelected
                ? Colors.bubbleColor
                : blockWorkoutForDate
                ? "rgba(63, 123, 141, 0.15)"
                : isHovered
                ? "rgba(63, 123, 141, 0.1)"
                : Colors.whiteColor,
              borderRadius: 10,
              // marginTop: -5,
              opacity: blockWorkoutForDate || workoutForDate ? 0.5 : 1,
            }}
          >
            <Text
              style={{
                textAlign: "center",
                color: isSelected
                  ? Colors.backgroundColor
                  : isToday
                  ? Colors.bubbleColor
                  : "black",
                fontWeight: isSameMonth ? (isToday ? "900" : "600") : "normal",
                opacity: isSameMonth ? 1 : 0.5,
                fontSize: 16,
                paddingTop: 8,
              }}
            >
              {date.day}
            </Text>

            {blockWorkoutForDate ? (
              <View
                style={{
                  flex: 1,
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "center",
                  paddingHorizontal: 5,
                }}
              >
                <Text style={{ fontSize: 11 }}>
                  W{blockWorkoutForDate.week}
                </Text>
              </View>
            ) : (
              <View
                style={{
                  flex: 1,
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  paddingHorizontal: 5,
                }}
              >
                <View
                  style={[
                    styles.circle,
                    {
                      backgroundColor: Colors.bodyweightColor,
                      opacity: bodyweightForDate ? 1 : 0,
                    },
                  ]}
                />
                <View
                  style={[
                    styles.circle,
                    {
                      backgroundColor: isSelected
                        ? Colors.backgroundColor
                        : Colors.bubbleColor,
                      opacity: workoutForDate ? 1 : 0,
                    },
                  ]}
                />
                <View
                  style={[
                    styles.circle,
                    {
                      backgroundColor: Colors.tracColor,
                      opacity: tracsForDate ? 1 : 0,
                    },
                  ]}
                />
              </View>
            )}
          </View>
        </TouchableOpacity>
      </View>
    );
  });

  const Cancel = () => {
    onClose();
  };

  const Buttons = ({ bool }) => {
    const text = bool ? "save-string" : "cancel-string";
    const Save = () => {
      block.workouts.forEach((w) => {
        w.setProperty("date", w.auxDate);
      });
      onClose();
    };

    const [isHovered, setIsHovered] = useState(false);

    return bool ? (
      <TouchableOpacity
        onPress={Save}
        style={{
          marginLeft: screenSize === "small" ? 8 : 10,
        }}
        onMouseEnter={() => !isMobile && setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <View
          style={{
            backgroundColor: Colors.bubbleColor,
            borderRadius: 14,
            borderWidth: 1,
            justifyContent: "center",
            borderColor: Colors.bubbleColor,
            width: 80,
            height: 35,
            justifyContent: "center",
            alignItems: "center",
            opacity: isHovered ? 0.7 : 1,
          }}
        >
          <Text
            style={{
              textAlignVertical: "center",
              textAlign: "center",
              color: Colors.whiteColor,
            }}
          >
            {t(text)}
          </Text>
        </View>
      </TouchableOpacity>
    ) : (
      <TouchableOpacity
        onPress={Cancel}
        onMouseEnter={() => !isMobile && setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <View
          style={{
            // marginHorizontal: 20,
            backgroundColor: isHovered ? Colors.redColor : Colors.whiteColor,
            borderRadius: 14,
            borderWidth: 1,
            justifyContent: "center",
            borderColor: Colors.redColor,
            width: 80,
            height: 35,
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Text
            style={{
              textAlignVertical: "center",
              textAlign: "center",
              color: isHovered ? Colors.whiteColor : Colors.redColor,
            }}
          >
            {t(text)}
          </Text>
        </View>
      </TouchableOpacity>
    );
  };

  const BlockWeeksView = observer(() => {
    const WeekRowButton = observer(({ week, idx }) => {
      const [isHovered, setIsHovered] = useState(false);

      const timestamps = block.workouts
        .filter((w) => w.week === week && w.auxDate)
        .map((w) => new Date(w.auxDate).getTime())
        .filter((ts) => !isNaN(ts)); // guard against bad dates

      // 2) Compute min/max (or null if there aren’t any)
      const minDate = timestamps.length
        ? new Date(Math.min(...timestamps))
        : null;
      const maxDate = timestamps.length
        ? new Date(Math.max(...timestamps))
        : null;
      const workoutsThisWeek = block.workouts.filter(
        (w) => w.week === week && w.auxDate
      );
      const totalWorkoutsThisWeek = block.workouts.filter(
        (w) => w.week === week
      ).length;
      const allDated = workoutsThisWeek.length === totalWorkoutsThisWeek;

      return (
        <TouchableOpacity
          onPress={() => changeWeek(week)}
          style={[
            GlobalStyles.touchableRow,
            {
              width:
                screenSize === "medium"
                  ? "100%"
                  : screenSize === "large"
                  ? "100%"
                  : `calc((100% - ${
                      screenSize === "small" ? 8 : 48
                    }px) / ${2})`,
              shadowColor: Colors.bubbleColor,
              borderWidth: selectedWeek === week ? 1 : 0.1,
              borderColor:
                selectedWeek === week
                  ? Colors.blackColor
                  : isHovered
                  ? "rgba(0, 0, 0, 0.5)"
                  : Colors.borderColor,
              // height: "auto",
            },
          ]}
          onMouseEnter={() => !isMobile && setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <View style={{ alignItems: "flex-start", flex: 1, gap: 8 }}>
            <Text
              numberOfLines={2}
              style={[
                screenSize != "large" ? Fonts.medium14 : Fonts.medium14,
                {},
              ]}
            >
              {block.getWeekName(week)
                ? block.getWeekName(week)
                : t("weekWithNumber-string", { week: week })}
            </Text>
            {minDate && maxDate ? (
              <View style={GlobalStyles.HStack}>
                <Ionicons
                  name="calendar"
                  size={12}
                  color={Colors.bubbleColor}
                  style={{ paddingRight: 2 }}
                />
                <Text
                  style={{
                    fontSize: screenSize != "large" ? 11 : 12,
                    color: "gray",
                  }}
                  numberOfLines={1}
                >
                  {format(minDate, "dd/MM")} - {format(maxDate, "dd/MM")}
                </Text>
                {allDated && (
                  <Ionicons
                    name="checkmark-circle"
                    size={13}
                    style={{ marginLeft: 8 }}
                    color={Colors.bubbleColor}
                  />
                )}
              </View>
            ) : (
              <View style={GlobalStyles.HStack}>
                <Ionicons
                  name="calendar"
                  size={12}
                  color={Colors.bubbleColor}
                  style={{ paddingRight: 2 }}
                />
                <Text
                  style={{
                    fontSize: screenSize != "large" ? 11 : 12,
                    color: "gray",
                  }}
                  numberOfLines={1}
                >
                  {t("withoutDate-string")}
                </Text>
              </View>
            )}
            {/* Debug: list this week’s scheduled workouts */}
            {/* <Observer>
              {() =>
                workoutsThisWeek
                  .filter((w) => w.auxDate)
                  .map((w, i) => (
                    <Text
                      key={i}
                      style={{
                        fontSize: 10,
                        color: "red",
                        alignSelf: "flex-end",
                        marginTop: 2,
                      }}
                    >
                      {w.name} {format(new Date(w.auxDate), "dd/MM")}
                    </Text>
                  ))
              }
            </Observer> */}
          </View>
        </TouchableOpacity>
      );
    });

    return (
      <View
        style={{
          flex: screenSize !== "large" && 1,
          height: "100%",
          flexWrap: "wrap",
          flexDirection: screenSize === "small" ? "row" : "column",
          gap: screenSize === "small" ? 8 : 12,
        }}
      >
        {Array.from({ length: block.getWeeks }, (_, i) => i + 1).map(
          (week, idx) => (
            <WeekRowButton key={week} week={week} idx={idx} />
          )
        )}
      </View>
    );
  });

  const changeWeek = (newWeek) => {
    setSelectedWeek(newWeek);
    // determine first auxDate of that week
    const workoutsOfWeek = block.workouts
      .filter((w) => w.week === newWeek && w.auxDate)
      .sort((a, b) => a.order - b.order);
    if (workoutsOfWeek.length > 0) {
      const firstAux = new Date(workoutsOfWeek[0].auxDate);
      // Always set to the 1st day of the month to avoid date issues
      const newMonthDate = new Date(
        firstAux.getFullYear(),
        firstAux.getMonth(),
        1
      );
      setCurrentMonth(newMonthDate);
    }
  };

  return (
    <Modal
      animationType="fade"
      transparent={true}
      visible={isVisible}
      onRequestClose={onClose}
    >
      <View style={GlobalStyles.centeredView}>
        <TouchableOpacity
          onPress={Cancel}
          style={GlobalStyles.touchableBackground}
        >
          <View />
        </TouchableOpacity>
        <View
          style={{
            position: "absolute",
            alignItems: "center",
            width: screenSize !== "small" && 600,
            maxHeight: "90%",
            maxWidth: "90%",
            minWidth: 320,
          }}
          onStartShouldSetResponder={() => false}
        >
          <ScrollView
            showsVerticalScrollIndicator={false}
            style={{ flex: 1, width: "100%" }}
          >
            <View
              style={[
                styles.modalView,
                {
                  width: "100%",
                  flexDirection:
                    screenSize === "small" ? "column-reverse" : "row",
                  paddingVertical: screenSize === "small" ? 8 : 24,
                },
              ]}
            >
              {screenSize != "small" ? (
                <View
                  style={{
                    position: "absolute",
                    top: 0,
                    bottom: 0,
                    left: 0,
                    width: SIDE_MENU_SIZE,
                    zIndex: 1,
                  }}
                >
                  <ScrollView
                    showsVerticalScrollIndicator={false}
                    contentContainerStyle={{
                      paddingVertical: 24,
                      paddingLeft: 24,
                      paddingRight: 16,
                    }}
                  >
                    <BlockWeeksView />
                  </ScrollView>
                </View>
              ) : (
                <View style={{ marginHorizontal: 8, marginTop: 16 }}>
                  <BlockWeeksView />
                </View>
              )}

              {screenSize != "small" && (
                <View
                  style={{
                    width: 1,
                    backgroundColor: Colors.borderColor,
                    alignSelf: "stretch",
                    marginLeft: screenSize !== "small" ? SIDE_MENU_SIZE : 0,
                    marginRight: 5,
                  }}
                />
              )}

              <View
                style={{
                  paddingRight: screenSize === "small" ? 0 : 16,
                  flex: 1,
                }}
              >
                <CustomCalendarHeader
                  currentMonth={currentMonth}
                  onMonthChange={handleMonthChange}
                />

                <View>
                  <CustomDayHeader />
                  <Calendar
                    firstDay={1}
                    key={`${currentMonth.getFullYear()}-${currentMonth.getMonth()}`}
                    style={{
                      width: "100%",
                      paddingHorizontal: 0,
                    }}
                    current={`${currentMonth.getFullYear()}-${String(
                      currentMonth.getMonth() + 1
                    ).padStart(2, "0")}-01`}
                    dayComponent={({ date, state }) => {
                      return <CardView date={date} />;
                    }}
                    hideArrows={true}
                    renderHeader={(date) => null}
                    hideDayNames
                    theme={{
                      backgroundColor: Colors.whiteColor, // background color for the calendar
                      calendarBackground: Colors.whiteColor, // background color for the day
                      monthTextColor: "black", // color for the month's name
                      textMonthFontSize: 25, // Adjust as needed (optional)
                      textDayHeaderFontSize: 15,
                      textSectionTitleColor: "black",
                      textDayHeaderFontWeight: "700",
                      weekVerticalMargin: 8,
                    }}
                  />
                </View>

                <Text
                  style={{
                    alignSelf: "center",
                    color:
                      weekWorkouts.filter((w) => w.auxDate).length !==
                      weekWorkouts.length
                        ? Colors.redColor
                        : Colors.bubbleColor,
                    fontSize: 16,
                    fontWeight: "500",
                    marginTop: 8,
                  }}
                >
                  {weekWorkouts.filter((w) => w.auxDate).length} /{" "}
                  {weekWorkouts.length}
                  {"  "}
                  <Text
                    style={{
                      fontSize: 15,
                    }}
                  >
                    {t("workoutsSelected-string")}
                  </Text>
                </Text>
              </View>
            </View>
          </ScrollView>
        </View>
      </View>
    </Modal>
  );
});

const styles = StyleSheet.create({
  modalView: {
    borderRadius: 18,
    backgroundColor: Colors.whiteColor,
  },
  circle: {
    width: 5,
    height: 5,
    borderRadius: 50, // Half of the width/height
  },
});

export default AddToCalendarView;
